var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderLineGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7873 0.545456H13.6737V11.9318C13.6737 12.7841 13.4862 13.5426 13.1112 14.2074C12.7418 14.8665 12.2077 15.3864 11.5089 15.767C10.81 16.142 9.97479 16.3295 9.0032 16.3295C8.03161 16.3295 7.19638 16.142 6.49751 15.767C5.80433 15.3864 5.27024 14.8665 4.89524 14.2074C4.52024 13.5426 4.33274 12.7841 4.33274 11.9318V0.545456H2.21911V12.1023C2.21911 13.2955 2.49751 14.3608 3.05433 15.2983C3.61683 16.2301 4.40661 16.9659 5.42365 17.5057C6.4407 18.0398 7.63388 18.3068 9.0032 18.3068C10.3725 18.3068 11.5657 18.0398 12.5827 17.5057C13.5998 16.9659 14.3867 16.2301 14.9435 15.2983C15.506 14.3608 15.7873 13.2955 15.7873 12.1023V0.545456ZM0 20.5H18V19.5H0V20.5Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderLineGray);
export default __webpack_public_path__ + "static/media/Under_Line_Gray.90b7b789f23766b709e1e4b0fc59c3cb.svg";
export { ForwardRef as ReactComponent };